module.exports = __webpack_public_path__ + "assets/media/status.fd0bc24a.svg";